import { setupDevtoolsPlugin } from '@vue/devtools-api';

// @vue/devtools-api 8 dropped the `DevtoolsPluginApi` type export — the package is now a thin
// re-export of @vue/devtools-kit. Deriving the type from the setup callback keeps this pinned to
// whatever the installed version actually hands us, rather than to a name that moved once already.
type DevtoolsApi = Parameters<Parameters<typeof setupDevtoolsPlugin>[1]>[0];

let devtoolsApi: DevtoolsApi | undefined = undefined;

const deepEmitLayer = 'deep-emits';
const formLayer = 'custom-forms';

export function setupDevtools(app: any) {
    setupDevtoolsPlugin(
        {
            id: 'edumetic-devtools',
            label: 'Edumetic',
            packageName: 'edumetic',
            app,
            enableEarlyProxy: true,
        },
        api => {
            devtoolsApi = api;
            api.addTimelineLayer({
                id: deepEmitLayer,
                color: 0xff2233,
                label: 'Deep Emits',
            });
            api.addTimelineLayer({
                id: formLayer,
                color: 0x32fa2a,
                label: 'Forms',
            });
        },
    );
}

export const logDeepEmit = (
    title: string,
    sender: symbol,
    senderParent: symbol | null | undefined,
    targets: { id: symbol; parentId: symbol | undefined }[],
    allListeners: any,
    payload: any,
) => {
    if (devtoolsApi == null) {
        return;
    }
    devtoolsApi.addTimelineEvent({
        layerId: deepEmitLayer,
        event: {
            title,
            data: {
                sender,
                senderParent,
                targets,
                allListeners,
                payload,
            },
            time: devtoolsApi.now(),
            groupId: title,
        },
    });
};

export const logSuccessfulFormSubmission = (title: string, data: any, result: any) => {
    if (devtoolsApi == null) {
        return;
    }
    devtoolsApi.addTimelineEvent({
        layerId: formLayer,
        event: {
            title,
            data: {
                type: 'submit:succeeded',
                data,
                result,
            },
            time: devtoolsApi.now(),
            groupId: title,
        },
    });
};

export const logFailedFormSubmission = (title: string, data: any, error: any) => {
    if (devtoolsApi == null) {
        return;
    }
    devtoolsApi.addTimelineEvent({
        layerId: formLayer,
        event: {
            title,
            data: {
                type: 'submit:failed',
                data,
                error,
            },
            time: devtoolsApi.now(),
            groupId: title,
        },
    });
};

export const logFailedFormValidation = (title: string, data: any, errors: any) => {
    if (devtoolsApi == null) {
        return;
    }
    devtoolsApi.addTimelineEvent({
        layerId: formLayer,
        event: {
            title,
            data: {
                type: 'validation:failed',
                data,
                errors,
            },
            time: devtoolsApi.now(),
            groupId: title,
        },
    });
};
